<template>
  <div>
    <v-row
      v-for="(field, i) in this.fields"
      :key="field.label"
      align="center"
      :class="field.editable ? 'py-1' : 'py-0'"
      no-gutters
    >
      <v-col
        cols="auto"
        class="pr-2"
        v-if="!field.isActive && field.value && field.editable"
      >
        {{ field.label }}:
      </v-col>

      <!-- FIELD -->
      <v-col v-if="field.isActive || field.value">
        <v-text-field
          :label="field.label"
          :disabled="!field.isActive"
          @keyup.enter="updateField(field, i)"
          v-model="field.value"
          single-line
          hide-details
          :class="
            field.editable
              ? 'body-1 py-0 my-0 mr-5'
              : 'title py-0 my-0'
          "
        />
      </v-col>

      <v-col v-if="!field.isActive && !field.value">
        <!-- ADD TEXT -->
        <v-btn
          class="underline pa-0"
          @click="activateFieldEditMode(field)"
          text
          small
          color="secondary"
        >
          Add {{ field.label }}
        </v-btn>
      </v-col>

      <v-col
        v-if="field.editable"
        cols="auto"
      >
        <v-btn
          v-if="!field.isActive && !field.value"
          x-small
          fab
          icon
          color="secondary"
          @click="activateFieldEditMode(field)"
        >
          <v-icon
            dark
            small
          >
            add
          </v-icon>
        </v-btn>

        <!-- SAVE BTN -->
        <v-btn
          v-if="field.isActive"
          x-small
          fab
          icon
          :color="field.value ? 'secondary' : 'grey'"
          @click="updateField(field, i)"
        >
          <v-icon
            v-if="!field.value"
            dark
            small
          >
            close
          </v-icon>

          <v-icon
            v-else
            dark
            small
          >
            check
          </v-icon>
        </v-btn>

        <!-- EDIT BTN -->
        <v-btn
          v-if="!field.isActive && field.value"
          x-small
          fab
          icon
          color="grey"
          @click="activateFieldEditMode(field)"
        >
          <v-icon
            dark
            small
          >
            edit
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { trackControlEdit, trackControlCloseEditing } from '@/segmentAnalytics/profile'

interface IFormField {
  label: string
  name: string
  isActive: boolean,
  value: string|number|Array<any>|boolean
  editable: boolean
  onClick: () => {}
}

@Component
export default class FormFields extends Vue {
  @Prop({ required: true }) fields: IFormField[]

  updateField (field: IFormField, i: number) {
    trackControlCloseEditing(field.name)
    this.$store.dispatch('updateProfile', {
      [field.name] : field.value || null
    })
    this.fields[i].isActive = false
  }

  activateFieldEditMode (field: IFormField) {
    trackControlEdit(field.name)
    field.isActive = true
  }
}
</script>
<style lang="scss" scoped>
.underline {
  text-decoration: underline;
}
.v-input ::v-deep .v-label {
  font-size: 1rem;
}

.v-input ::v-deep .mdi-close {
  font-size: 1.3rem;
}
.v-input--is-disabled {
  color: var(--v-grey-base);
}
</style>
